/* eslint-disable react/no-unknown-property */
import React, { PureComponent } from 'react';

import classNames from 'classnames';
import Settings from 'configs/Settings';
import PropTypes from 'prop-types';

import './UserPhoto.scss';

const MAX_ATTEMPS = 4;
const ATTEMP_DELAY = 3000;

export default class UserPhoto extends PureComponent {
  // #region set up
  static propTypes = {
    backgroundImage: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.number,
    name: PropTypes.string,
    photo: PropTypes.string,
    pictureThumbId: PropTypes.number,
    pictureFileKey: PropTypes.string,
    size: PropTypes.string,
    width: PropTypes.number,
    shouldRetryLoad: PropTypes.bool
  };

  static defaultProps = {
    height: 40,
    name: '',
    size: '',
    width: 40
  };

  get imageThumbnailApi() {
    const { pictureFileKey } = this.props;
    const apiVersion = pictureFileKey ? '4' : '3';

    return `${Settings.api.hotClub}/rest/v${apiVersion}/thumbor/imageThumbnail`;
  }

  state = {
    imgError: false,
    attemps: 0
  };
  // #endregion

  // #region helpers
  get firstLetter() {
    const { name } = this.props;

    return name.charAt(0).toUpperCase();
  }

  get colorClass() {
    const { photo } = this.props;

    return photo && !this.state.imgError
      ? ''
      : `bg--color--${this.firstLetter.toLowerCase()}`;
  }

  get classComponent() {
    const { className, size } = this.props;

    return classNames('profile__image', this.colorClass, className, {
      'profile__image--big': size === 'big',
      'profile__image--small': size === 'small',
      'profile__image--medium': size === 'medium'
    });
  }

  get pictureThumbUrl() {
    const { pictureThumbId, pictureFileKey, height, width } = this.props;

    return `${this.imageThumbnailApi}?fmID=${
      pictureFileKey || pictureThumbId
    }&height=${height}&width=${width}`;
  }
  // #endregion

  retryLoad = () => {
    this.setState({ imgError: false });
  };

  // #region handlers
  onImgError = () => {
    const { attemps } = this.state;
    const { shouldRetryLoad } = this.props;
    const tryReload = shouldRetryLoad && attemps < MAX_ATTEMPS;

    this.setState({ imgError: true, attemps: attemps + 1 });
    tryReload && setTimeout(this.retryLoad, ATTEMP_DELAY);
  };
  // #endregion

  // #region render
  render() {
    const { backgroundImage, photo, pictureThumbId, pictureFileKey } =
      this.props;
    const { imgError } = this.state;

    if (!imgError) {
      if (photo || pictureThumbId || pictureFileKey) {
        return this.renderPhoto(photo || this.pictureThumbUrl);
      } else if (backgroundImage) {
        return this.renderBackgroundImage(photo);
      }
    }

    return this.renderLetter();
  }

  renderPhoto(photo) {
    return (
      <img
        alt={name}
        className={this.classComponent}
        onError={this.onImgError}
        src={photo}
      />
    );
  }

  renderBackgroundImage(photo) {
    return (
      <div
        className={this.classComponent}
        onError={this.onImgError}
        style={{ backgroundImage: `url(${photo})` }}
      />
    );
  }

  renderLetter() {
    return <span className={this.classComponent}>{this.firstLetter}</span>;
  }
  // #endregion
}
